// @flow

/** @jsx jsx */
import { jsx } from '@emotion/core'
import * as React from 'react'
import ToggleButtonGroupAction from './ToggleButtonGroupAction'
import type { CommonActionProps } from './types.actions'
import Loading from '../Loading'
import BlockingLoadingStatus from '../BlockingLoadingStatus'
import { DesktopView, MobileView } from '../../config/mediaQuery'
import Dropdown from '../Dropdown'

type Props = {
  onClick: (filters: any) => void,
  filters: any,
}

const FILTER_TYPE = 'OrderType'
const OPTIONS = [
  {
    id: 'allOrders',
    value: 'all',
    text: 'All Orders',
  },
  {
    id: 'dailySales',
    value: 'dailySales',
    text: 'Daily Sales',
  },
  {
    id: 'mobos',
    value: 'mobos',
    text: 'MOBOs',
  },
  {
    id: 'futures',
    value: 'futures',
    text: 'Futures',
  },
  {
    id: 'samples',
    value: 'samples',
    text: 'Samples',
  },
]

const FILTERS = {
  all: null,
  dailySales: {
    not: {
      Hold: {
        in: ['MO', 'BO', 'IN', 'BH', 'SM'],
      },
    },
    ShpDate: {}
  },
  mobos: {
    Hold: {
      in: ['MO', 'BO', 'IN', 'BH'],
    },
  },
  futures: {
    not: {
      Hold: {
        in: ['MO', 'BO', 'IN', 'BH', 'SM'],
      },
    },
  },
  samples: {
    Hold: 'SM',
  },
}

class OrderTypeFilterAction extends React.Component<
  Props & CommonActionProps & ApolloConsumerProps,
> {
  static defaultProps = {
    size: 'xsmall',
    disabled: false,
    filterType: FILTER_TYPE,
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedFilter: 'all',
      status: '',
      dailySalesResponse: {}
    }
  }

  oldDerivedStateFromProps(nextProps: Props) {
    if (nextProps.saveStatus === 'reset') {
      return this.setState({
        selectedFilter: 'all',
      });
    }

    return null
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }
  }

  handleChange = async (value) => {
    const filter = FILTERS[value]

    this.setState({
      selectedFilter: value,
    })

    this.props.onClick(this.props.filterType, {
      ...filter,
    })
  }

  render() {
    const { size, disabled } = this.props
    const isLoading = this.state.status === 'loading'

    return (
      <>
        <DesktopView>
          <div css={{ position: 'relative' }}>
            {isLoading && (
              <BlockingLoadingStatus
                active={isLoading}
                container={document.body}
                text={<Loading />}
                excludeHeader={true}
              />
            )}
            <ToggleButtonGroupAction
              onChange={this.handleChange}
              bsSize={size}
              disabled={disabled || isLoading}
              type="radio"
              value={this.state.selectedFilter}
              options={OPTIONS}
              name="dateFilter"
            />
          </div>
        </DesktopView>
        <MobileView>
          <Dropdown
            id="dateFilter"
            disabled={disabled || isLoading}
            onChange={this.handleChange}
            selected={this.state.selectedFilter}
            options={OPTIONS}
          />
        </MobileView>
      </>

    )
  }
}

export default OrderTypeFilterAction
